/* eslint-disable */
export default {
  callerCall: 'Soittaja',
  transferCall: 'Siirto',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
